var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-icon',{attrs:{"size":_vm.large ? 'x-large' : undefined,"color":_vm.type === 'relation' ? 'tracefyOrange' : ''}},[_vm._v(_vm._s(_vm.icon))])}
var staticRenderFns = []

export { render, staticRenderFns }